import React from 'react';

const ServicesPage = () => {
  return (
    <div>
      <h1>Services Page</h1>
    </div>
  );
};

export default ServicesPage;